import React, { useContext } from 'react'; // useState
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { uiContext } from 'contexts/UIContext';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

interface DebugProps {
  data?: any;
  hidden?: boolean;
  open?: boolean;
  sx?: SxProps<Theme>;
  children?: React.ReactNode;
}

const DebugContainer: React.FC<DebugProps> = ({ sx = {}, data, open = undefined, hidden = false, children }) => {
  const { debugMode } = useContext(uiContext);
  if (!debugMode) return null;
  return (
    <Accordion
      expanded={open}
      disableGutters
      elevation={0}
      sx={{
        ...sx,
        display: hidden ? 'none' : 'block',
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary sx={{ pl: 0 }} expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1">Debug</Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: 0,
          overflowX: 'auto',
        }}
      >
        {children}
        <pre>
          {
            // @ts-ignore
            JSON.stringify(data, 0, 2)
          }
        </pre>
      </AccordionDetails>
    </Accordion>
  );
};

export default DebugContainer;
